export class ResponseStatuses {
  static Success = 'success'
  static Fail = 'fail'
}
